// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__SyntR","header":"Graph_header__36bDd","options":"Graph_options__LgXFZ"};